import React from 'react';

const whatsapp=()=>{

            const phone_number="6289001010";

            const message="Hii i want to know brocheure";
            const handleClick=()=>{
                const url=`https://wa.me/${phone_number}?text=${encodeURIComponent(message)}`;
                window.location.href=url;
            }
     
       

         return(
            <div>


        <button className="whatsapp-button" onClick={handleClick} aria-label="Chat on WhatsApp">
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        className="whatsapp-icon"
      />
    </button>
     
     <style>
 {`.whatsapp-button {
 margin-top:15px;
          position: fixed;
          bottom: 20px;
          right: 20px;
          background-color: #25d366;
          border: none;
          border-radius: 50%;
          padding: 12px;
          cursor: pointer;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
          z-index: 1000;
          transition: transform 0.2s ease-in-out;
          margin-top:15px
        }

        .whatsapp-button:hover {
          transform: scale(1.1);
          background-color: #25d366 !important;
          color: inherit !important;
        }

        .whatsapp-icon {
          width: 40px;
          height: 40px;
        }`}
     </style>

     </div>
         )
}

export default whatsapp;